/**
 * Interval in milliseconds between heartbeat checks.
 * Legacy uses 15 seconds (15000ms).
 */
export const HEARTBEAT_INTERVAL_MS = 15000;